export const getters = {
  expert: state => state.expert,
  experts: state => state.experts
}

const GET_EXPERTS = 'expert/experts'

export const gettersTypes = {
  GET_EXPERTS
}
export default getters



// WEBPACK FOOTER //
// ./src/store/module/expert/getters.js